<template>
  <van-popup v-model="show" position="bottom" closeable>
    <div class="pop-box">
        <div class="title">{{ pageTitle }}</div>
        <div class="price-list">
            <div class="price-items" :class="{'activeItem':activePrice === item.name}" v-for="item in priceList1 " :key="item.name" @click="handleClick(item)">
                {{item.name}}元
            </div>
        </div>
        <div class="price-list" style="margin-bottom: 32px;">
            <div class="price-items" :class="{'activeItem':activePrice === item.name}" v-for="item in priceList2 " :key="item.name" @click="handleClick(item)">
                {{item.name}}元
            </div>
            <div class="costomer-price-items">
                <van-field
                    v-model="costomerPirce"
                    input-align="center"
                    placeholder="自定义金额"
                    type="number"
                    placeholder-style="color:#C9C2BB;"
                    @focus="handleFocus"
                    style="font-size:14px;background-color: #F5F1EF;height:32px;padding:0 16px;line-height:32px;"
                ></van-field>
            </div>
        </div>
        <van-button color="#EC892E" block style="height:38px;" @click="handleAddPrice">确认</van-button>
    </div>
  </van-popup>
</template>

<script>
import { Field , Button , Toast , Dialog } from 'vant';


export default {
  name: 'MobileMapAddPricePopup',
    components:{ 
    [Field.name]: Field,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
   },
  data() {
    return {
      show:false,
      priceList1:[
        {name:10,checked:false},
        {name:20,checked:false},
        {name:50,checked:false},
        {name:100,checked:false},
      ],
      priceList2:[
        {name:200,checked:false},
        {name:500,checked:false},
      ],
      costomerPirce:null,
      activePrice:null,//选择的价格
      pageTitle:''
    };
  },

  methods: {
    init({title}){
        this.pageTitle = title?title:'订单加价'
        this.show = true;
    },
    handleAddPrice(){
        if(!this.activePrice && !this.costomerPirce){
            Toast(`请先选择${this.pageTitle}金额`);
            return;
        }
        if(this.costomerPirce >= 99999){
            Toast('金额过高，请重新输入');
            this.costomerPirce = null;
            return;
        }else if(!this.activePrice && this.costomerPirce < 1){
            Toast('最低金额为1元');
            this.costomerPirce = null;
            return;
        }
        
        let resultPrice = this.activePrice?this.activePrice:this.costomerPirce;
        Dialog.confirm({
            title: this.pageTitle,
            message: `是否确认${this.pageTitle}，金额为${resultPrice}元？`,
        })
        .then(async () => {
            this.$emit('confirmPrice',resultPrice)
            this.show = false;
        })
        
        
    },
    handleClick(item){
        this.activePrice = item.name;
        this.costomerPirce = null;
    },
    handleFocus(){
        this.activePrice = '';
    }
  },
};
</script>

<style lang="scss" scoped>
    .pop-box {
        padding: 16px 12px;
        margin-bottom: 10px;
        .title {
            font-size: 16px;
            color: #333333;
            margin-bottom: 24px;
        }
        .price-list {
            display: flex;
            flex-wrap: nowrap;
        }
        .price-items {
            width: 76px;
            height: 32px;
            border-radius: 4px;
            border: 1px solid #F5F1EF;
            background-color: #F8F8F8;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 12px;
            margin-bottom: 12px;
            &:nth-child(4){
                margin-right: 0;
            }
        }
        .activeItem {
            border: 1px solid #EC892E;
            background-color: #FDF3E9;
            color: #EC892E;
        }
        .costomer-price-items {
            flex: 1;
            height: 32px;
            border-radius: 4px;
            border: 1px solid #F5F1EF;
            background-color: #F8F8F8;
        }
        ::v-deep van-cell {
            width:100%;
            height: 100%;
            padding: 0;
        }
    }
</style>